import { ActionIcon, Tooltip } from "@mantine/core";
import { PropsWithChildren } from "react";

import { ExportBtnCSV } from "./ExportBtnCSV";
import { ExportBtnPDF } from "./ExportBtnPDF";

function ExportBtnImpl({ children }: PropsWithChildren) {
  return (
    <Tooltip.Group openDelay={200} closeDelay={100}>
      <ActionIcon.Group>{children}</ActionIcon.Group>
    </Tooltip.Group>
  );
}

export const ExportBtn = Object.assign(ExportBtnImpl, {
  CSV: ExportBtnCSV,
  PDF: ExportBtnPDF,
  displayName: "ExportBtn"
});
